<template>
  <div>
    <form class="form-container" @submit.prevent="purchaseProduct">
      <!-- for scrappable Product Only -->
      <div v-if="!this.productDetails.client_id" class="scrappableProductOnly">
        <multiselect
          v-model="product.category"
          :options="categoryNames"
          label="name"
          track-by="id"
          :searchable="true"
          :close-on-select="true"
          :show-labels="false"
          :class="{ error: $v.product.category.$error }"
          :placeholder="$t('selectProdCat2')"
          @blur="$v.product.cateogry.$touch()"
        ></multiselect>
        <br />
        <div style="margin: auto;">
          <button
            :disabled="$v.$invalid"
            class="add-btn"
            type="submit"
            name="button"
          >
            {{ $t('add') }}
          </button>
        </div>

        <br />
      </div>
      <!-- End  -->

      <!-- for Wholesalable Product Only -->
      <div v-else class="wholesaleProductOnly">
        <p>{{ $t('wholesaleProductCategoryNotif') }}</p>
        <MarketPlaceProductCategoryCard
          :productDetails="productDetails"
          :product="product"
          :categoryExistence="categoryExistence"
          @change-category="changeCategory"
        ></MarketPlaceProductCategoryCard>
      </div>

      <!-- End of prod. category details -->
    </form>
  </div>
</template>

<script>
// import NProgress from 'nprogress'
import { required } from 'vuelidate/lib/validators'
import MarketPlaceProductCategoryCard from '../../components/ui/MarketPlaceProductCategoryCard.vue'

export default {
  components: {
    MarketPlaceProductCategoryCard
  },
  data() {
    return {
      errors: null,
      product: {
        category: ''
      },
      prodCatId: undefined
    }
  },
  validations: {
    product: {
      category: { required }
    }
  },
  async mounted() {
    if (this.productDetails.client_id) {
      if (
        this.categoryExistence.exist === true &&
        this.categoryExistence.categoryId
      ) {
        this.$emit('hide-product-purchase-form', null)
        this.prodCatId = this.categoryExistence.categoryId
        await this.purchaseProduct()
      }
    }
  },
  methods: {
    async purchaseProduct() {
      try {
        const productBody = {
          parent_product_id: this.productDetails.product_id,
          client_id: this.inquireDetails.id,
          name: this.productDetails.product_name,
          description: this.productDetails.description,
          purchase_price: this.productDetails.wholesale_price,
          price: this.productDetails.sugg_selling_price,
          stock_general: 0,
          img_path: this.productDetails.img_path,
          img_name: this.productDetails.img_name,
          img_size: this.productDetails.img_size,
          shippable: 0,
          wholesalable: 0,
          selfService: 1
        }
        productBody.prodCat_id = this.productDetails.client_id
          ? this.prodCatId
          : this.product.category.id
        productBody.parent_product_type = this.productDetails.client_id
          ? 'OWN'
          : 'ECOMMERCE'
        await this.$store.dispatch(
          'marketPlace/purchaseMarketPlaceProduct',
          productBody
        )
        alert(this.$t('productPurchased'))
        this.$emit('hide-product-purchase-form', null)
      } catch (error) {
        alert(this.$t('tryLater'))
        this.$emit('hide-product-purchase-form', null)
      }
    },
    changeCategory(categoryId) {
      if (categoryId !== null) this.prodCatId = categoryId
      this.purchaseProduct()
    }
  },
  props: {
    productDetails: {
      type: Object,
      default: () => {
        return {}
      }
    },
    inquireDetails: {
      type: Object,
      default: () => {
        return {}
      }
    },
    categoryNames: {
      type: Array,
      default: () => {
        return []
      }
    },
    categoryExistence: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.optionalData {
  background-color: var(--grey-light);
  border: 1px solid var(--grey);
  padding: 0 20px;
  width: 100%;
}
.optional {
  text-align: center;
  letter-spacing: 5px;
  color: var(--bg);
}
.form-container {
  //position: absolute;
  background: #fff;
  color: var(--bg);
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0px 0px 8px 0px #000;
  width: auto;
}

.form-container p {
  color: var(--bg);
}

.InquirerMessage {
  height: 200px;
}

form .selectCountry {
  text-align: left;
  margin-bottom: 0px;
  color: #747474;
  width: 100%;
  margin-top: 10px;
  padding-left: 5px;
}

.inputStyle {
  margin-bottom: 24px;
  width: 100%;
  display: block;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.field {
  margin-bottom: 24px;
}

a:visited {
  color: #2c3e50;
}

.button,
button {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: linear-gradient(to right, $secondary, $secondary-dark);
  font-size: 1.5em;
  color: white;
  border: none;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  outline: none;
  margin: auto;
}

button:disabled,
button[disabled] {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}

form {
  display: flex;
  text-align: left;
  flex-direction: column;

  p {
    color: red;
  }
}

input {
  display: block;
  box-sizing: border-box;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  width: 100%;
  height: 2.6em;
  padding: 0.5em;
  margin-bottom: 1em;
  font: 1em 'Lato', Helvetica, sans-serif;
}

textarea {
  display: block;
  box-sizing: border-box;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  font: 1em 'Lato', Helvetica, sans-serif;
}

.bgOptional {
  background: rgb(252, 250, 250);
}

h1 {
  margin-top: 0;
}

.add-btn {
  background: var(--primaryDark);
  border-radius: 5px;
  color: var(--bright);
  padding: 0.3em;
  letter-spacing: 3px;
  width: 80%;
}

.errorMessage {
  font-size: 0.8em;
  margin-top: -10px;
  color: var(--primaryDark) !important;
}

@media screen and (max-width: 560px) {
  .optionalData {
    padding: 10px;
  }
}
</style>
